import { FC, ReactElement } from 'react';

import { useDialog } from 'hooks/useDialog';

import CategorySelect from 'components/categorySelect/CategorySelect';
import { TextButton } from 'components/sharedElements/sharedElements';
import TagList from 'components/tagList/TagList';
import CategoryInfoDialog from 'components/utkast/categoryInfoDialog/CategoryInfoDialog';

import { HuvudgruppTyp } from 'models/apiModels/HuvudgruppTyp';
import { HuvudkategoriTyp } from 'models/apiModels/HuvudkategoriTyp';
import { UnderkategoriTyp } from 'models/apiModels/UnderkategoriTyp';
import { AndamalTag } from 'models/appModels/AndamalTag';

const extractAndamalTag = (item: HuvudkategoriTyp | UnderkategoriTyp): AndamalTag => {
  if ('underkategorityp_id' in item) {
    return {
      namn: item.definition,
      definitionstext: item.definitionstext,
      id: item.underkategorityp_id,
      nyckelord: item.nyckelord,
      kategorityp: 'UNDERKATEGORI',
      aktiv: item.aktiv
    };
  } else if ('huvudkategorityp_id' in item) {
    return {
      namn: item.definitionsnamn,
      definitionstext: item.definitionstext,
      id: item.huvudkategorityp_id,
      nyckelord: item.nyckelord,
      kategorityp: 'HUVUDKATEGORI',
      aktiv: item.aktiv
    };
  }
  throw new Error('Onåbar, detta bör inte ske :^)');
};

interface CategoriesWithTagListProps {
  categoriesSelectDisabled?: boolean;
  categories: HuvudgruppTyp[];
  bebyggelseobjekgrupp: string;
  label: string;
  id: string;
  setTagList: (data: Array<AndamalTag>) => void;
  onRemoveTag: (item: AndamalTag) => void;
  tagList: Array<AndamalTag>;
  disabledList?: Array<AndamalTag>;
  hasError?: boolean;
}

const CategoriesWithTagList: FC<CategoriesWithTagListProps> = ({
  categoriesSelectDisabled = false,
  categories,
  bebyggelseobjekgrupp,
  label,
  id,
  setTagList,
  onRemoveTag,
  tagList,
  disabledList = [],
  hasError
}): ReactElement => {
  const { setDialog, unsetDialog } = useDialog();

  return (
    <>
      <label className="raa-label tw-mt-4" htmlFor={id}>
        {label}
      </label>
      <CategorySelect
        disabledItems={[...tagList, ...disabledList]}
        disabled={categoriesSelectDisabled}
        placeholder="Skriv för att filtrera"
        inputId={id}
        classNames="tw-mb-2"
        list={categories?.filter((category: HuvudgruppTyp) => category.huvudgrupptyp === bebyggelseobjekgrupp)}
        onSelect={(item) => setTagList([extractAndamalTag(item)])}
        hasError={hasError}
      />

      <TagList
        list={tagList}
        itemClassName="tw-py-0"
        leftColumn={(item) => (
          <TextButton onClick={() => setDialog(CategoryInfoDialog, { andamal: item, unsetDialog })}>
            {item.namn}
          </TextButton>
        )}
        onRemoveItem={onRemoveTag}
      />
    </>
  );
};

export default CategoriesWithTagList;
